import { type CommonData, Country } from "../../../../types/common";
import { getApplicantAddress } from "../../../../utils/contact.helper";
import { NormalInfoWrapper } from "../../../tasks/styles";

interface OfferDetailsProps {
  data: CommonData;
}

interface Detail {
  label: string;
  value: any;
}

function getIndexOfLastRow(details: Detail[]) {
  let lastValidRow = -1;
  for (let i = 0; i < details.length; i++) {
    if (details[i].value != null) {
      lastValidRow = i;
    }
  }
  return [lastValidRow];
}

export const ApplicantRow = ({ data }: OfferDetailsProps) => {
  const applicant = data?.agentApiApplication?.applicant;
  const country = data.country;
  // Finland sources the applicant score fields from its own statistica endpoint.
  const scorecard =
    country === Country.FI
      ? data?.integrations?.statistica?.FI_Scorecard
      : data?.integrations?.statistica?.SE_Scorecard;

  const applicantDetails = [
    { label: "Age", value: scorecard?.variables?.Applicant_Age },
    { label: "Address", value: getApplicantAddress(data) },
    { label: "Living conditions", value: applicant.dwelling?.type },
    { label: "Marital status", value: applicant.maritalStatus },
    { label: "Children (under 18)", value: applicant.numberOfChildrenBelow18 },
    { label: "Employment status", value: applicant.employment?.type },
    { label: "Employer", value: applicant.employment?.employer }
  ];
  const lastIndexes = getIndexOfLastRow(applicantDetails);
  return (
    <>
      <NormalInfoWrapper $header>Applicant Details</NormalInfoWrapper>
      {applicantDetails.map((detail, index) => {
        if (detail.value === null || detail.value === undefined) {
          return;
        }
        return (
          <NormalInfoWrapper
            key={`offer - ${detail.label}`}
            $isLast={lastIndexes.includes(index)}
          >
            <div>{detail.label}</div>
            <div style={{ textAlign: "end" }}>{detail.value}</div>
          </NormalInfoWrapper>
        );
      })}
    </>
  );
};
